import {get} from "lodash";
import {useSelector} from "react-redux";
import {TFunction, useTranslation} from "react-i18next";
import {Duration} from "luxon";
import {getContest} from "modules/selectors";
import {HRS_IN_DAY, MIN_IN_HOUR, MS_IN_SECOND, SEC_IN_DAY, SEC_IN_HOUR} from "modules/constants";
import {useCountDownTimer} from "./useTimer";

const getTimerText = (t: TFunction, time: Duration) => {
	const milliseconds = time.milliseconds;
	const secToFinish = Math.floor(milliseconds / MS_IN_SECOND);
	const days = Math.floor(secToFinish / SEC_IN_DAY);
	const hours = Math.floor(secToFinish / SEC_IN_HOUR) % HRS_IN_DAY;
	const minutes = Math.floor(secToFinish / MIN_IN_HOUR) % MIN_IN_HOUR;
	return `${days} ${t("timer.days")} ${hours} ${t("timer.hours")} ${minutes} ${t("timer.min")}`;
};

export const useDescriptionTimer = () => {
	const {t} = useTranslation();
	const contest = useSelector(getContest);

	const lockDate = get(contest, "endDate", "");
	const time = useCountDownTimer(lockDate);
	const timerText = getTimerText(t, time);
	return `${t("summary.description")} ${timerText}`;
};
